import React, { FC, useCallback, useState } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
//constants
import ICONS from '../../constants/icons';

//components
import AampeTooltip from './AampeTooltip/AampeTooltip';

interface CopyToClipboardBoxProps {
    copyData: string;
    isCode?: boolean;
}
const CopyToClipboardBox: FC<CopyToClipboardBoxProps> = ({
    copyData,
    isCode = false,
}) => {
    const [isDataCopied, setIsDataCopied] = useState<boolean>(false);

    const clickHandler = useCallback((text: string, isDataCopied: boolean) => {
        navigator.clipboard.writeText(text);
        setIsDataCopied(isDataCopied);
        setTimeout(() => {
            setIsDataCopied(false);
        }, 5000);
    }, []);
    return (
        <CopyContainer>
            <CopyText isCode={isCode}>{copyData}</CopyText>
            <AampeTooltip
                placement="top"
                arrow
                title={isDataCopied ? 'Copied' : 'Copy'}
            >
                <IconContainer>
                    <CopyIcon
                        onClick={() => clickHandler(copyData, true)}
                        size={20}
                    />
                </IconContainer>
            </AampeTooltip>
        </CopyContainer>
    );
};

const CopyContainer = styled.div({
    borderRadius: aampeTheme.borderRadius.default,
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    padding: aampeTheme.spacing4(4),
    display: 'flex',
    flexDirection: 'column',
});

const CopyText = styled.div.withConfig({
    shouldForwardProp: (prop) => !['isCode'].includes(prop),
})<{ isCode: boolean }>(({ isCode }) => ({
    fontFamily: isCode ? 'monospace' : 'inherit',
    fontSize: aampeTheme.size.font.default,
    lineHeight: aampeTheme.size.lineHeight.small,
    fontWeight: aampeTheme.weights.light,
    color: aampeTheme.colors.neutral09,
    display: 'flex',
    whiteSpace: 'pre-wrap',
}));

const IconContainer = styled.div({
    alignSelf: 'end',
});

const CopyIcon = styled(ICONS.copy)({
    color: aampeTheme.colors.solidA01,
    marginTop: aampeTheme.spacing4(2),
    alignSelf: 'end',
    cursor: 'pointer',
});
export default CopyToClipboardBox;
